// extracted by mini-css-extract-plugin
export default {"invite":"AlertingChip_invite__5nkq6"};